export enum StepEnum {
  ETAPE_TYPE_PROPRIETE = 1,
  AIGUILLEUR_RESIDENCE_PRINCIPALE,
  AIGUILLEUR_MULTIPROPRIETAIRE,
  AIGUILLEUR_SALARIE,
  AIGUILLEUR_CITOYENNETE,
  ETAPE_COEMPRUNTEUR,
  ETAPE_CONSENTEMENT,
  ETAPE_REVENU_BRUT,
  ETAPE_ACHAT_A_DEUX,
  ETAPE_MEME_COEMPRUNTEUR,
  ETAPE_HYPOTHEQUE,
  ETAPE_PRIX_PROPRIETE,
  ETAPE_REVENU_LOCATIF,
  ETAPE_MISE_DE_FONDS,
  ETAPE_COORDONNEES,
  ETAPE_RECAP,
  ETAPE_ACCEPTER_PROJET
}
